import { CertDdosChartSubscription } from "./cert-ddos-chart.rgql";

export const validProduct = (s: CertDdosChartSubscription) =>
  (s.productType === "FW" && s.surfcertFilterEnabled) || s.productType === "IP";
